import { Recycle } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card">
      <div className="container mx-auto flex flex-col items-center gap-4 px-4 py-8 text-center md:flex-row md:justify-between md:text-left">
        <div className="flex items-center gap-2">
          <Recycle className="h-5 w-5 text-primary" />
          <span className="font-heading text-sm font-semibold text-foreground">
            Deal<span className="text-primary">Swapify</span>
          </span>
        </div>
        <p className="text-xs text-muted-foreground">
          © 2026 DealSwapify. Buy less, swap more. 🌱
        </p>
        
      </div>
    </footer>
  );
};

export default Footer;
